
const SLOT_REGEX = /\{[a-zA-Z0-9]{1,}\}/g

export default {
  name: 'I18n',

  props: {
    path: {
      type: String,
      required: true
    },

    tag: {
      type: String,
      default: 'span'
    }
  },

  methods: {
    format(inputString) {
      const splitWithMatches = []
      let lastIndex = 0

      inputString.replace(SLOT_REGEX, (match, index) => {
        // previous substring
        if (index > lastIndex) {
          splitWithMatches.push(inputString.substring(lastIndex, index))
        }

        // replace {slot} with <slot/>
        const slotName = match.slice(1, -1)
        const slot = isNaN(slotName)
          ? this.$slots[slotName]
          : this.$slots[slotName] ?? this.$slots.default?.[slotName]

        if (slot !== undefined) {
          splitWithMatches.push(slot || match)
        }

        lastIndex = index + match.length
      })

      // rest
      if (lastIndex < inputString.length) {
        splitWithMatches.push(inputString.substring(lastIndex))
      }

      return splitWithMatches
    }
  },

  render(h) {
    const translation = this.$t(this.path)
    const children = this.format(translation)

    return h(this.tag, children)
  }
}
